import styles from "./ReportarBug.module.css";
import { useEffect, useState } from "react";
import axios from "axios";
import load from "../../../../../Images/loading.gif";

function ReportarBug({ user, app }) {
    const [bugs, setBugs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [success, setSuccess] = useState(false);

    useEffect(() => {
        fetchBugs();
    });

    const fetchBugs = () => {
        axios.get(`https://eclipsebots.com/api/bugs/${app}`, { withCredentials: true })
            .then((res) => setBugs(res.data))
            .catch(() => setBugs([]))
            .finally(() => setLoading(false));
    };

    const handleCreateBug = async (event) => {
        event.preventDefault();

        const formData = new FormData(event.target);
        const bug = {
            userId: user.id,
            serviceId: app,
            bug: formData.get("description")
        };

        await fetch("https://eclipsebots.com/api/bugs/create", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            credentials: "include",
            body: JSON.stringify({ bug })
        });

        setLoading(true);
        setSuccess(true);
        event.target.reset();
        fetchBugs();

        setTimeout(() => {
            setSuccess(false);
        }, 4000);
    };

    if (loading) {
        return (
            <div className={styles.content}>
                <div className={`${styles.size} ${styles.loading}`}>
                    <img src={load} width="20px" height="20px" alt="loading" />
                </div>
            </div>
        );
    }

    return (
        <div className={styles.container}>
            <h3>Reportar Bug</h3>
            <p>Descreve o erro encontrado, o que causou, e como podemos reproduzir.</p>

            {success && <p className={styles.successMessage}>✅ Bug reportado com sucesso!</p>}

            <form className={styles.form} onSubmit={handleCreateBug}>
                <textarea
                    required
                    name="description"
                    placeholder="Exemplo: Ao clicar no botão X, aparece o erro Y"
                    className={styles.textarea}
                />
                <button type="submit" className={styles.button}>Submeter</button>
            </form>

            {bugs.length === 0 ? (
                <div>Sem bugs reportados</div>
            ) : (
                <div className={styles.bugs}>
                    <span className={styles.reportados}>Bugs Reportados:</span>
                    {bugs.map((event, index) => {
                        const isFirst = index === 0;
                        const isLast = index === bugs.length - 1;

                        return (
                            <div
                                key={event.bugId}
                                className={`
                                    ${styles.bug}
                                    ${isFirst ? styles.first : ""}
                                    ${isLast ? styles.last : ""}
                                `}
                            >
                                <div className={`${styles.emoji} ${styles.imagem}`}>
                                    {getEmoji(event.type)}
                                </div>
                                <div className={`${styles.name} ${styles.imagem}`}>
                                    {limitString(`${event.bug}`, 100)}
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
}

function limitString(str, maxLength) {
    return str.length > maxLength ? str.substring(0, maxLength) + '...' : str;
}

const getEmoji = (type) => {
    switch (type) {
        case "acknowledge": return "🟢";
        case "disclaim": return "🛠️";
        default: return "⚠️";
    }
};

export default ReportarBug;
